import type { ModeloDefaultProps } from "../../banner-fixo.props"
import ConteudoBanner from "../conteudoBanner/ConteudoBanner"

export default function Modelo09({ data }: ModeloDefaultProps) {

    const banners = data.banners.slice(0, 5)
    const device = data.device

    return (
        <div className="fixed-banners fixed-banners-tipo9 container">
            <div className="item-banner flex center justify-center">

                {banners[0] && (
                    <div className="banner-size">
                        <ConteudoBanner data={{
                            banner: banners[0],
                            device
                        }} />
                    </div>
                )}

                <div className="banner-column flex column">
                    {banners.slice(1, 6).map(currentBanner => (
                        <ConteudoBanner data={{
                            banner: currentBanner,
                            device: data.device
                        }} />
                    ))}
                </div>
            </div>
        </div>
    )
}